import { render, staticRenderFns } from "./changelog_ai_banner.vue?vue&type=template&id=20a3f2ee&"
import script from "./changelog_ai_banner.vue?vue&type=script&lang=js&"
export * from "./changelog_ai_banner.vue?vue&type=script&lang=js&"
import style0 from "./changelog_ai_banner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports